import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  AuditLogFilter,
  PaginatedAuditLogResponse,
  AuditLogEntry,
  AuditLogSummary,
  AuditLogStaff,
  AuditLogServiceInterface,
} from "../types/auditLog.types";

export class AuditLogService
  extends BaseService
  implements AuditLogServiceInterface
{
  async getAuditLog(
    filter: AuditLogFilter,
  ): Promise<ApiResult<PaginatedAuditLogResponse>> {
    const params = this.buildQueryParams(filter as Record<string, unknown>);
    return this.handleRequest<PaginatedAuditLogResponse>(
      this.client.get("/api/admin/audit-log", { params }),
    );
  }

  async getAuditLogEntry(
    id: string,
    source: string,
  ): Promise<ApiResult<AuditLogEntry>> {
    return this.handleRequest<AuditLogEntry>(
      this.client.get(`/api/admin/audit-log/${id}/${source}`),
    );
  }

  async getSummary(): Promise<ApiResult<AuditLogSummary>> {
    return this.handleRequest<AuditLogSummary>(
      this.client.get("/api/admin/audit-log/summary"),
    );
  }

  async getStaffList(): Promise<ApiResult<AuditLogStaff[]>> {
    return this.handleRequest<AuditLogStaff[]>(
      this.client.get("/api/admin/audit-log/staff"),
    );
  }

  async exportCsv(filter: AuditLogFilter): Promise<ApiResult<Blob>> {
    const params = this.buildQueryParams(filter as Record<string, unknown>);
    return this.handleRequest<Blob>(
      this.client.get("/api/admin/audit-log/export", {
        params,
        responseType: "blob",
      }),
    );
  }
}
